export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Counts'
    },
    unique: [],
    sort: false,
    lang: {
        name: 'Play Counts',
        category: ['User', 'Plays'],
        description: 'Summary of counts played at for a game.',
        views: ['list', 'grid'],
        contexts: ['collection', 'ratings', 'gameplays'],
    },
    filters: []
}